import { render } from "./ConnectionsPage.vue?vue&type=template&id=3b6fb216"
import script from "./ConnectionsPage.vue?vue&type=script&lang=js"
export * from "./ConnectionsPage.vue?vue&type=script&lang=js"

import "./ConnectionsPage.vue?vue&type=style&index=0&id=3b6fb216&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__